import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  EnachTransacInputs,
  LedgerTrades,
  TCashObj,
  TClickDetails,
  TClickReports,
  TCustomerCategoryRiskDetails,
  TCustomerCreditReportObj,
  TCustomerEnachDetailsObj,
  TEnachTransactions,
  TmPowerCProductData,
  TOnoScoreTotalsObj,
  TOrgProduct,
  TPlatformAgreementDetails,
  TPlatformUseGetData,
  TTradeDetailsObj,
  TTradeObj,
} from "../types/customers";
import {
  MarketDetails,
  TAddress,
  TAddcheque,
  TPaymentTerms,
  TraderStatus,
  TTraderId,
  WalletData,
  WalletEntities,
  WalletTrades,
} from "../types";
import moment from "moment";

type TinitialState = {
  clickResponse: TClickDetails | null;
  tradeResponse: TTradeDetailsObj | null;
  cashResponse: TCashObj | null;
  clickReports: TClickReports | null;
  clickFarmerReports: TClickReports | null;
  selectedTrade: LedgerTrades | null;
  refreshCustomerEntity: boolean;
  markets: MarketDetails[];
  traderStatus: TraderStatus[];
  refreshBorrowerEntity: boolean;
  selectedMosUser: TmPowerCProductData | null;
  activeEnityTab: TOrgProduct | null;
  refreshSelectedDate: boolean;
  activeProductTypeTab: string;
  refreshSearchCustomerEntity: boolean;
  addPlatformAgreement: TPlatformAgreementDetails;
  selectedUsePlatform: TPlatformUseGetData | null;
  refreshPlatformAgreement: boolean;
  includeExpired: boolean;
  selectedStatuses: string[];
  activeTab: string;
  activeTradeTypeTab: string;
  activeTraderDualTypeTab: string;
  isEditAgre: boolean;
  selectedTraderId: number;
  analyseBtnStatus: boolean;
  makePmtSteps: number;
  isMakePmtOpen: boolean;
  walletEntities: WalletEntities[];
  mosId: number;
  walletTrades: WalletTrades[];
  walletData: WalletData | null;
  filterWalletLedger: any[];
  selectedEntity: number;
  selectedWalletTrade: any;
  walletAmount: number;
  walletComments: string;
  walletSearch: string;
  filterWalletTrades: any[];
  refreshWalletLedger: boolean;
  selectedVaId: string;
  isClickOnAddShip: boolean;
  isRefreshAllTraders: boolean;
  staticPmtTermLabelList: TPaymentTerms[];
  riscScoreViewPanelStatus: boolean;
  customerRiscScroreTotals: TOnoScoreTotalsObj | null;
  customerCategoryRiscScroreData: TCustomerCategoryRiskDetails | null;
  customerMosId: number;
  customerCreditReportDetails: TCustomerCreditReportObj;
  tradeDetailsProfile: TTraderId | null;
  refreshCustomerTradeDetailsEntity: boolean;
  addCheque: TAddcheque[];
  chequeStatus: "SECURITY_CHEQUE" | "edit" | "view";
  chequeFieldChange: boolean;
  refreshGetAllTradeDetails: boolean;
  activeProfileProductTypeTab: string;
  customerEnachMandateDetails: TCustomerEnachDetailsObj;
  enachMandateDetails: TCustomerEnachDetailsObj[];
  selectedMandateId: number;
  eNachActiveTab: string;
  eNachTransactions: TEnachTransactions[];
  eNachTransactionInput: EnachTransacInputs;
  isInvokeEnach: "table" | "edit" | "";
  openEnachPmt: boolean;
  selectedTransacPmt: TEnachTransactions;
  states: string[];
};
const initialState: TinitialState = {
  clickResponse: null,
  tradeResponse: null,
  cashResponse: null,
  clickReports: null,
  clickFarmerReports: null,
  selectedTrade: null,
  refreshCustomerEntity: false,
  markets: [],
  traderStatus: [],
  refreshBorrowerEntity: false,
  selectedMosUser: null,
  activeEnityTab: null,
  refreshSelectedDate: false,
  activeProductTypeTab: "",
  refreshSearchCustomerEntity: false,
  refreshPlatformAgreement: false,
  addPlatformAgreement: {
    traderId: 0,
    id: 0,
    traderName: "",
    traderMobile: "",
    traderEmail: "",
    companyName: "",
    companyMobile: "",
    companyEmail: "",
    status: "",
    cuatomerSignedOn: "",
    companySignedOn: "",
    executedOn: "",
    type: "",
    isNew: false,
    tradeName: "",
    traderAddress: {
      city: "",
      country: "",
      locality: "",
      pincode: "",
      state: "",
      street_address: "",
    },
    signerName: "",
  },
  selectedUsePlatform: null,
  includeExpired: true,
  selectedStatuses: [],
  activeTab: "ALL",
  activeTradeTypeTab: "OPEN",
  activeTraderDualTypeTab: "SELL",
  isEditAgre: false,
  selectedTraderId: 0,
  analyseBtnStatus: false,
  makePmtSteps: 1,
  isMakePmtOpen: false,
  walletEntities: [],
  mosId: 0,
  walletTrades: [],
  walletData: null,
  filterWalletLedger: [],
  selectedEntity: 0,
  selectedWalletTrade: null,
  walletAmount: 0,
  walletComments: "",
  walletSearch: "",
  filterWalletTrades: [],
  refreshWalletLedger: false,
  selectedVaId: "",
  isClickOnAddShip: false,
  isRefreshAllTraders: false,
  staticPmtTermLabelList: [],
  riscScoreViewPanelStatus: false,
  customerRiscScroreTotals: null,
  customerCategoryRiscScroreData: null,
  customerMosId: 0,
  customerCreditReportDetails: {
    pan: "",
    firstName: "",
    lastName: "",
    gender: "",
    dateOfBirth: "",
  },
  tradeDetailsProfile: null,
  refreshCustomerTradeDetailsEntity: false,
  addCheque: [],
  chequeStatus: "view",
  chequeFieldChange: false,
  refreshGetAllTradeDetails: false,
  activeProfileProductTypeTab: "",
  customerEnachMandateDetails: {
    name: "",
    mobile: "",
    email: "",
    amount: "",
    startDate: "",
    endDate: "",
    accNum: "",
    accType: "",
    ifscCode: "",
    paymentType: "",
    mandateStatus: "",
    id: 0,
    referenceId: "",
    enachMandateId: "",
    bankCode: "",
    reqId: 0,
    type: "",
  },
  enachMandateDetails: [],
  selectedMandateId: 0,
  eNachActiveTab: "MANDATE_DETAILS",
  eNachTransactions: [],
  eNachTransactionInput: {
    amount: "",
    ifsc: "",
    date: moment().format("YYYY-MM-DD"),
  },
  isInvokeEnach: "",
  openEnachPmt: false,
  selectedTransacPmt: {
    id: 0,
    reqId: 0,
    type: "",
    mandateId: 0,
    enachMandateId: "",
    createdBy: "",
    amount: 0,
    fileRefId: "",
    txnStatus: "",
    userRefId: "",
    transId: "",
    ifscCode: "",
    createdOn: "",
  },
  states: []
};
const customerSlice = createSlice({
  name: "customers",
  initialState: initialState,
  reducers: {
    setClickResponse: (state, action) => {
      state.clickResponse = action.payload || null;
    },
    setTradeResponse: (state, action) => {
      state.tradeResponse = action.payload || null;
    },
    setCashResponse: (state, action) => {
      state.cashResponse = action.payload || null;
    },
    setClickReportsResponse: (state, action) => {
      state.clickReports = action.payload || null;
    },
    setClickFarmerReportsResponse: (state, action) => {
      state.clickFarmerReports = action.payload || null;
    },
    setRefreshCustomerEntity: (state) => {
      state.refreshCustomerEntity = !state.refreshCustomerEntity;
    },
    setMarketDetails: (state, action) => {
      state.markets = action.payload;
    },
    setTraderStatus: (state, action) => {
      state.traderStatus = action.payload;
    },
    showTradeLedgerSummary: (
      state,
      action: PayloadAction<LedgerTrades | null>,
    ) => {
      state.selectedTrade = action.payload;
    },
    setRefreshBorrowerEntity: (state) => {
      state.refreshBorrowerEntity = !state.refreshBorrowerEntity;
    },
    setSeletedMosUser: (state, action) => {
      state.selectedMosUser = action.payload;
    },
    setActiveEntityTab: (state, action) => {
      state.activeEnityTab = action.payload || null;
      state.activeTradeTypeTab = "OPEN";
    },
    setRefreshSelectedDate: (state) => {
      state.refreshSelectedDate = !state.refreshSelectedDate;
    },
    setActiveProductTypeTab: (state, action) => {
      state.activeProductTypeTab = action.payload || "";
      state.activeTradeTypeTab = "OPEN";
    },
    setRefreshSearchCustomerEntity: (state) => {
      state.refreshSearchCustomerEntity = !state.refreshSearchCustomerEntity;
    },
    setPlatformUseDetails: (
      state,
      action: PayloadAction<{
        traderId: number;
      }>,
    ) => {
      state.addPlatformAgreement = {
        traderId: action.payload.traderId,
        id: 0,
        traderName: "",
        traderMobile: "",
        traderEmail: "",
        companyName: "Rama Rao Kancharapu",
        companyMobile: "8337922222",
        companyEmail: "rama@onoark.com",
        status: "",
        cuatomerSignedOn: "",
        companySignedOn: "",
        executedOn: "",
        type: "",
        isNew: false,
        tradeName: "",
        traderAddress: {
          city: "",
          country: "INDIA",
          locality: "",
          pincode: "",
          state: "",
          street_address: "",
        },
        signerName: "",
      };
    },
    updatePlatformUseDetails: (
      state,
      action: PayloadAction<{
        addPlatformAgreement: TPlatformAgreementDetails;
      }>,
    ) => {
      state.addPlatformAgreement = action.payload.addPlatformAgreement;
    },
    setSelectedPlatformUse: (
      state,
      action: PayloadAction<TPlatformUseGetData>,
    ) => {
      state.selectedUsePlatform = action.payload;
    },
    setRefreshPlatformAgreement: (state) => {
      state.refreshPlatformAgreement = !state.refreshPlatformAgreement;
    },
    setIncludeExpired(state, action: PayloadAction<boolean>) {
      state.includeExpired = action.payload;
    },
    setSelectedStatuses: (state, action: PayloadAction<string[]>) => {
      state.selectedStatuses = action.payload;
    },
    setCustomerActiveTab: (state, action: PayloadAction<string>) => {
      state.activeTab = action.payload;
    },
    UpdateActiveTradeTypeTab: (state, action: PayloadAction<string>) => {
      state.activeTradeTypeTab = action.payload;
    },
    UpdateActiveTraderDualTypeTab: (state, action: PayloadAction<string>) => {
      state.activeTraderDualTypeTab = action.payload;
    },
    setIsEditAgree: (state, action: PayloadAction<boolean>) => {
      state.isEditAgre = action.payload;
    },
    setSelectedTraderId: (state, action: PayloadAction<number>) => {
      state.selectedTraderId = action.payload;
    },
    setAnalyseBtnStatus: (state, action: PayloadAction<boolean>) => {
      state.analyseBtnStatus = action.payload;
    },
    setMakePmtSteps: (state, action) => {
      state.makePmtSteps = action.payload;
    },
    setIsMakePmtOpen: (state, action: PayloadAction<boolean>) => {
      state.isMakePmtOpen = action.payload;
    },
    setWalletEntities: (state, action: PayloadAction<WalletEntities[]>) => {
      state.walletEntities = action.payload;
    },
    setMosId: (state, action: PayloadAction<number>) => {
      state.mosId = action.payload;
    },
    setWalletTrades: (state, action: PayloadAction<WalletTrades[]>) => {
      state.walletTrades = action.payload;
    },
    setWalletData: (state, action: PayloadAction<WalletData | null>) => {
      state.walletData = action.payload;
    },
    setFilterWalletLedger: (state, action: PayloadAction<any[]>) => {
      state.filterWalletLedger = action.payload;
    },
    setSelectedEntity: (state, action: PayloadAction<number>) => {
      state.selectedEntity = action.payload;
    },
    setSelectedWalletTrade: (state, action: PayloadAction<any>) => {
      state.selectedWalletTrade = action.payload;
    },
    setWalletAmount: (state, action: PayloadAction<number>) => {
      state.walletAmount = action.payload;
    },
    setWalletComments: (state, action: PayloadAction<string>) => {
      state.walletComments = action.payload;
    },
    setWalletSearch: (state, action: PayloadAction<string>) => {
      state.walletSearch = action.payload;
    },
    setFilterWalletTrades: (state, action: PayloadAction<any[]>) => {
      state.filterWalletTrades = action.payload;
    },
    setRefreshWalletLedger: (state) => {
      state.refreshWalletLedger = !state.refreshWalletLedger;
    },
    setSelectedVaId: (state, action: PayloadAction<string>) => {
      state.selectedVaId = action.payload;
    },
    setIsClickOnAddShip: (state, action: PayloadAction<boolean>) => {
      state.isClickOnAddShip = action.payload;
    },
    setIsRefreshAllTraders: (state) => {
      state.isRefreshAllTraders = !state.isRefreshAllTraders;
    },
    setStaticPmtTermLabelList: (
      state,
      action: PayloadAction<TPaymentTerms[]>,
    ) => {
      state.staticPmtTermLabelList = action.payload;
    },
    setRiscScoreViewPanelStatus: (state, action: PayloadAction<boolean>) => {
      state.riscScoreViewPanelStatus = action.payload;
    },
    setCustomerRiscScroreTotals: (
      state,
      action: PayloadAction<TOnoScoreTotalsObj | null>,
    ) => {
      state.customerRiscScroreTotals = action.payload;
    },
    setCustomerCategoryRiscScrore: (
      state,
      action: PayloadAction<TCustomerCategoryRiskDetails | null>,
    ) => {
      state.customerCategoryRiscScroreData = action.payload;
    },
    // new
    setCustomerMosId: (state, action: PayloadAction<number>) => {
      state.customerMosId = action.payload;
    },
    updateCreditReportDetails: (
      state,
      action: PayloadAction<{
        customerCreditReportDetails: TCustomerCreditReportObj;
      }>,
    ) => {
      state.customerCreditReportDetails =
        action.payload.customerCreditReportDetails;
    },
    setTraderDeilsObj: (state, action: PayloadAction<TTraderId | null>) => {
      state.tradeDetailsProfile = action.payload;
    },
    resetCreditReportForm: (state, action: PayloadAction<any>) => {
      const cibil = action.payload;
      console.log(action.payload, "action.payload?.cibilData");
      state.customerCreditReportDetails = {
        ...state.customerCreditReportDetails,
        pan: cibil?.pan ?? "",
        firstName: cibil?.firstName ?? "",
        lastName: cibil?.lastName ?? "",
        gender: cibil?.gender ?? "",
        dateOfBirth: cibil?.dob ?? "",
      };
    },
    setRefreshCustomerTradeDetailsEntity: (state) => {
      state.refreshCustomerTradeDetailsEntity =
        !state.refreshCustomerTradeDetailsEntity;
    },
    setAddCheque: (state, action: PayloadAction<TAddcheque[]>) => {
      state.addCheque = action.payload;
    },
    setChequeStatus: (
      state,
      action: PayloadAction<"SECURITY_CHEQUE" | "edit" | "view">,
    ) => {
      state.chequeStatus = action.payload;
    },
    setChequeFieldChange: (state, action: PayloadAction<boolean>) => {
      state.chequeFieldChange = action.payload;
    },

    setActiveProfileProductTypeTab: (state, action: PayloadAction<string>) => {
      state.activeProfileProductTypeTab = action.payload;
    },
    updateEnachMandateDetails: (
      state,
      action: PayloadAction<{
        customerEnachMandateDetails: TCustomerEnachDetailsObj;
      }>,
    ) => {
      state.customerEnachMandateDetails =
        action.payload.customerEnachMandateDetails;
    },
    setAllEnachMandateDetails: (
      state,
      action: PayloadAction<{
        enachMandateDetails: TCustomerEnachDetailsObj[];
      }>,
    ) => {
      state.enachMandateDetails = action.payload.enachMandateDetails;
    },
    setSelectedMandateId: (
      state,
      action: PayloadAction<{
        selectedMandateId: number;
      }>,
    ) => {
      state.selectedMandateId = action.payload.selectedMandateId;
    },
    setEnachActiveTab: (state, action: PayloadAction<string>) => {
      state.eNachActiveTab = action.payload;
    },
    setEnachTransactions: (
      state,
      action: PayloadAction<TEnachTransactions[]>,
    ) => {
      state.eNachTransactions = action.payload;
    },
    setENachTransactionInput: (
      state,
      action: PayloadAction<EnachTransacInputs>,
    ) => {
      state.eNachTransactionInput = action.payload;
    },
    setIsInvokeEnach: (state, action: PayloadAction<"table" | "edit" | "">) => {
      state.isInvokeEnach = action.payload;
    },
    setOpenEnachPmt: (state, action: PayloadAction<boolean>) => {
      state.openEnachPmt = action.payload;
    },
    setSelectedTransacPmt: (
      state,
      action: PayloadAction<TEnachTransactions>,
    ) => {
      state.selectedTransacPmt = action.payload;
    },
    resetEnachMandateForm: (
      state,
      action: PayloadAction<{
        data: any;
        type: string;
        reqId: number;
      }>,
    ) => {
      const apiData = action.payload.data;
      let payoutActiveAccount = null;
      if (apiData && apiData.length > 0) {
        payoutActiveAccount = apiData.find(
          (account: any) => account.status === 1,
        );
      }
      const baseAccount = apiData?.[0] || {};
      state.customerEnachMandateDetails = {
        type: action.payload.type,
        mobile: baseAccount.mobile ?? "",
        email: baseAccount.email ?? "",
        name: payoutActiveAccount?.actHolder ?? baseAccount.actHolder ?? "",
        amount: "",
        startDate: "",
        endDate: "",
        accNum: payoutActiveAccount?.actNum ?? baseAccount.actNum ?? "",
        accType: payoutActiveAccount?.actType ?? "",
        ifscCode: payoutActiveAccount?.ifsc ?? baseAccount.ifsc ?? "",
        paymentType: "",
        id: 0,
        reqId: action.payload.reqId ?? 0,
      };
    },
    setState: (state, action: PayloadAction<string[]>) => {
      state.states = action.payload
    }
  },
});

export const {
  setClickResponse,
  setTradeResponse,
  setCashResponse,
  setClickReportsResponse,
  setClickFarmerReportsResponse,
  showTradeLedgerSummary,
  setRefreshCustomerEntity,
  setMarketDetails,
  setTraderStatus,
  setRefreshBorrowerEntity,
  setSeletedMosUser,
  setActiveEntityTab,
  setRefreshSelectedDate,
  setActiveProductTypeTab,
  setRefreshSearchCustomerEntity,
  setPlatformUseDetails,
  updatePlatformUseDetails,
  setSelectedPlatformUse,
  setRefreshPlatformAgreement,
  setIncludeExpired,
  setSelectedStatuses,
  setCustomerActiveTab,
  UpdateActiveTradeTypeTab,
  UpdateActiveTraderDualTypeTab,
  setIsEditAgree,
  setSelectedTraderId,
  setAnalyseBtnStatus,
  setMakePmtSteps,
  setIsMakePmtOpen,
  setWalletEntities,
  setMosId,
  setWalletTrades,
  setWalletData,
  setSelectedEntity,
  setFilterWalletLedger,
  setSelectedWalletTrade,
  setWalletAmount,
  setWalletComments,
  setWalletSearch,
  setFilterWalletTrades,
  setRefreshWalletLedger,
  setSelectedVaId,
  setIsClickOnAddShip,
  setIsRefreshAllTraders,
  setStaticPmtTermLabelList,
  setRiscScoreViewPanelStatus,
  setCustomerRiscScroreTotals,
  setCustomerCategoryRiscScrore,
  setCustomerMosId,
  updateCreditReportDetails,
  resetCreditReportForm,
  setTraderDeilsObj,
  setRefreshCustomerTradeDetailsEntity,
  setAddCheque,
  setChequeStatus,
  setChequeFieldChange,
  setActiveProfileProductTypeTab,
  updateEnachMandateDetails,
  setAllEnachMandateDetails,
  setSelectedMandateId,
  setEnachActiveTab,
  setEnachTransactions,
  setENachTransactionInput,
  setIsInvokeEnach,
  setOpenEnachPmt,
  setSelectedTransacPmt,
  resetEnachMandateForm,
  setState
} = customerSlice.actions;
export default customerSlice.reducer;
